var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnTopologyLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 21.25H21.75V22.75H17.25V21.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.25 18C21.25 15.9289 22.9289 14.25 25 14.25H26V15.75H25C23.7574 15.75 22.75 16.7574 22.75 18V26C22.75 27.2426 23.7574 28.25 25 28.25H26V29.75H25C22.9289 29.75 21.25 28.0711 21.25 26V18Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 20.5C11.25 19.2574 12.2574 18.25 13.5 18.25H16.5C17.7426 18.25 18.75 19.2574 18.75 20.5V23.5C18.75 24.7426 17.7426 25.75 16.5 25.75H13.5C12.2574 25.75 11.25 24.7426 11.25 23.5V20.5ZM13.5 19.75C13.0858 19.75 12.75 20.0858 12.75 20.5V23.5C12.75 23.9142 13.0858 24.25 13.5 24.25H16.5C16.9142 24.25 17.25 23.9142 17.25 23.5V20.5C17.25 20.0858 16.9142 19.75 16.5 19.75H13.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.25 13.5C25.25 12.2574 26.2574 11.25 27.5 11.25H30.5C31.7426 11.25 32.75 12.2574 32.75 13.5V16.5C32.75 17.7426 31.7426 18.75 30.5 18.75H27.5C26.2574 18.75 25.25 17.7426 25.25 16.5V13.5ZM27.5 12.75C27.0858 12.75 26.75 13.0858 26.75 13.5V16.5C26.75 16.9142 27.0858 17.25 27.5 17.25H30.5C30.9142 17.25 31.25 16.9142 31.25 16.5V13.5C31.25 13.0858 30.9142 12.75 30.5 12.75H27.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.25 27.5C25.25 26.2574 26.2574 25.25 27.5 25.25H30.5C31.7426 25.25 32.75 26.2574 32.75 27.5V30.5C32.75 31.7426 31.7426 32.75 30.5 32.75H27.5C26.2574 32.75 25.25 31.7426 25.25 30.5V27.5ZM27.5 26.75C27.0858 26.75 26.75 27.0858 26.75 27.5V30.5C26.75 30.9142 27.0858 31.25 27.5 31.25H30.5C30.9142 31.25 31.25 30.9142 31.25 30.5V27.5C31.25 27.0858 30.9142 26.75 30.5 26.75H27.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnTopologyLight);
export default __webpack_public_path__ + "static/media/btn_topology_light.ed4cd83b04fc92b8cf6bcdd93b457c7f.svg";
export { ForwardRef as ReactComponent };